module.exports = __webpack_public_path__ + "static/media/steinsgate.5913aa5f.mp3";